import axios from "./_axios";
import { API } from "./apiEndPoints";

export const loginEmailPW = async (params) => {
  let result = await axios(false)({
    method: "post",
    url: API.LOGIN,
    data: params,
  });
  return result;
};

export const LOGIN_ACCOUNT_PAGE_SIZE = 20;

/**
 * Accounts the authenticated user can select after login.
 * GET api/common/v2/user/{user_id}/account/
 * Pagination via offset/limit; optional backend search.
 */
export const getListofAccount = (user_id, queryParams = {}) => {
  const params = {
    offset: queryParams.offset ?? 0,
    limit: queryParams.limit ?? LOGIN_ACCOUNT_PAGE_SIZE,
  };
  if (queryParams.search != null && String(queryParams.search).trim() !== "") {
    params.search = String(queryParams.search).trim();
  }

  return axios()({
    method: "get",
    url: `${API.USER}${user_id}/account/`,
    params,
  });
};
